// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__-ZzrK","amount":"Amount_amount__3_9VC","tip":"Amount_tip__2GV8L","tipHeader":"Amount_tipHeader__14VPj","tipsWrap":"Amount_tipsWrap__-lCGe"};